<form>
  <div mat-dialog-content class="air-theme">

    <div fxLayout="row" class="flexwrap">

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.type.label' | translate }}</mat-label>
          <mat-select name="idType" [(ngModel)]="data.filter.idType"
            (selectionChange)="onChangeTypeFilter($event)" [disabled]="!enableEditEssay()">
            @for (item of this.data.filterTypes; track item) {
              <mat-option [value]="item.id">
                {{ 'filterType.' + item.translation | translate }}
              </mat-option>
            }
          </mat-select>
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.type.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      @if (showFiltersType) {
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.type.label' | translate }}</mat-label>
            <mat-select name="idTypeFilter" [(ngModel)]="data.filter.idTypeFilter" [disabled]="!enableEditEssay()">
              @for (item of this.data.accessoryFilterTypes; track item) {
                <mat-option [value]="item.id">
                  {{ 'filterType.' + item.translation | translate }}
                </mat-option>
              }
            </mat-select>
            <mat-error>
              {{ 'protocolEdit.dialog.equipment.type.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      }
       <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.identifier.filter.label' | translate }}</mat-label>
            <input matInput name="identifier" [(ngModel)]="data.filter.identifier" [disabled]="!enableEditEssay()">
          </mat-form-field>

       </div>
    </div>
    <div fxLayout="row" class="flexwrap">
      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-radio-group name="shape" (change)="onShapeChange($event)" [(ngModel)]="data.filter.shape"
          [disabled]="!enableEditEssay()">
          <mat-radio-button [value]="1">{{ 'filterShape.rectangular' | translate }}</mat-radio-button>
          <mat-radio-button [value]="2">{{ 'filterShape.circular' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div fxLayout="row" class="flexwrap">
      @if (showRectangular) {
        <div fxFlex="30" fxFlex.lt-md="100%">
          <div fxLayout="column">
            <div>
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'filterType.filter.air.filter.length' | translate }}</mat-label>
                <input matInput name="length" type="number"  min="0" [(ngModel)]="data.filter.length" [disabled]="!enableEditEssay()">
                <mat-error>
                  {{ 'protocolEdit.dialog.room.length.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      }
      @if (showRectangular) {
        <div fxFlex="30" fxFlex.lt-md="100%">
          <div fxLayout="column">
            <div>
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'filterType.filter.air.filter.width' | translate }}</mat-label>
                <input matInput name="width" type="number"  min="0" [(ngModel)]="data.filter.width" [disabled]="!enableEditEssay()">
                <mat-error>
                  {{ 'protocolEdit.dialog.room.height.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      }
      @if (showRectangular) {
        <div fxFlex="30" fxFlex.lt-md="100%">
          <div fxLayout="column">
            <div>
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'filterType.filter.air.filter.height' | translate }}</mat-label>
                <input matInput name="height" type="number"  min="0" [(ngModel)]="data.filter.height" [disabled]="!enableEditEssay()">
                <mat-error>
                  {{ 'protocolEdit.dialog.room.height.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      }

      @if (showDiameter) {
        <div fxFlex="30" fxFlex.lt-md="100%">
          <div fxLayout="column">
            <div>
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'filterType.filter.air.filter.diameter' | translate }}</mat-label>
                <input matInput name="size{{indexValue}}" type="number"  min="0" [(ngModel)]="data.filter.diameter"
                  [disabled]="!enableEditEssay()">
                <mat-error>
                  {{ 'protocolEdit.dialog.room.diameter.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      }

      @if (showTotalFiltersSecondStage()) {
        <div fxFlex="40" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.totalFiltersSecondStage.label' | translate }}</mat-label>
            <input matInput required min="0" name="totalFiltersSecondStage"
              [(ngModel)]="data.filter.totalFiltersSecondStage" type="number"
              [disabled]="!enableEditEssay()">
            <mat-error>
              {{ 'protocolEdit.dialog.equipment.totalFiltersSecondStage.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      }
    </div>

    @if (data.isExecution) {
      <div fxLayout="row" class="flexwrap">
        <div fxFlex="100%">
          <mat-radio-group name="changeFilter" [(ngModel)]="changeFilter" [disabled]="!enableEditEssay()">
            <span> {{ 'appPlanEdit.administration.changeFilter.label' | translate }} </span>
            <mat-radio-button [value]="true">{{ 'common.yes' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false">{{ 'common.no' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
        @if (changeFilter) {
          <div fxFlex="40" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'protocolEdit.dialog.equipment.maker.label' | translate }}</mat-label>
              <input matInput required name="maker" [(ngModel)]="data.filter.maker">
              <mat-error>
                {{ 'protocolEdit.dialog.equipment.maker.error' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        }
        @if (changeFilter) {
          <div fxFlex="40" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'protocolEdit.dialog.equipment.serialNum.label' | translate }}</mat-label>
              <input matInput required name="serialNum" [(ngModel)]="data.filter.serialNum"
                [disabled]="!enableEditEssay()">
              <mat-error>
                {{ 'protocolEdit.dialog.equipment.serialNum.error' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        }
        @if (changeFilter) {
          <div fxFlex="20" fxFlex.lt-md="100%">
            <button mat-icon-button (click)="uploadCertificateInput.click()" color="accent"
              matTooltip="{{ 'button.upload-certificate' | translate }}"
              [disabled]="!enableEditEssay()">
              <mat-icon>cloud_upload</mat-icon>
            </button>
            <input accept="application/pdf" hidden type="file" (change)="uploadCertificate($event)"
              #uploadCertificateInput>
            @if (data.filter.idCertificate != null) {
              <button mat-icon-button color="accent" (click)="downloadCertificate()"
                matTooltip="{{ 'button.download' | translate }}">
                <mat-icon>cloud_download</mat-icon>
              </button>
            }
          </div>
        }
      </div>
    }

  </div>

  <div mat-dialog-actions class="air-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>